import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, useCssModule } from 'vue'
import { PRIVACY_POLICY_NAVIGATION_ITEM } from '@/router/navigation-constants'
import { type FormSubmitData } from '@/types'
import { type RequestStatus } from '@/utils/requests/types'
import Button from '@/components_new/Button.vue'
import Link from '@/components_new/Link.vue'
import TextInput from '@/components_new/TextInput/TextInput.vue'
import Typography from '@/components_new/Typography.vue'
import { useTr } from '@/composables/use-tr'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactForm',
  props: /*@__PURE__*/_mergeModels({
    submitStatus: {},
    viewMode: {}
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["submit", "successButtonClicked", "formReset"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const classes = useCssModule()
const formData = _useModel<FormSubmitData>(__props, "modelValue")
const tr = useTr()

const privacyPolicyRoute = computed(() => PRIVACY_POLICY_NAVIGATION_ITEM(tr))

const hasSuccessfullySubmitted = computed(() => props.submitStatus === 'ok')
const isError = computed(() => props.submitStatus === 'error')
const isSending = computed(() => props.submitStatus === 'pending')
const areInputsDisabled = computed(() => isSending.value || hasSuccessfullySubmitted.value)
const hasMissingValues = computed(() => Object.values(formData.value).some((value) => !value.trim()))

const buttonProps = computed(() => {
    if (hasSuccessfullySubmitted.value) {
        return {
            // successs button resets the form and is never disabled
            disabled: false,
            color: 'lime' as const,
            iconLeft: 'check' as const,
            title: tr('contactForm.messageSent'),
            type: undefined,
            interfaceTarget: 'submited-form',
            onClick: () => emit('formReset'),
        }
    }

    return {
        disabled: areInputsDisabled.value || hasMissingValues.value,
        color: isError.value ? ('rose-400' as const) : ('purple-400' as const),
        type: 'submit' as const,
        interfaceTarget: isError.value ? 'error-form' : 'submit-form',
        title: isError.value ? tr('contactForm.error') : tr('contactForm.submit'),
        class: isError.value ? classes.shakeError : undefined,
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: _normalizeClass([_ctx.$style.form, { [_ctx.$style.modal]: _ctx.viewMode === 'modal' }]),
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (emit('submit', formData.value)), ["prevent"]))
  }, [
    _createVNode(TextInput, {
      id: "form-email",
      modelValue: formData.value.email,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event)),
      required: "",
      disabled: areInputsDisabled.value,
      size: "m",
      name: "email",
      type: "email",
      labelText: _ctx.$tr('contactForm.email'),
      placeholder: _ctx.$tr('contactForm.email')
    }, null, 8, ["modelValue", "disabled", "labelText", "placeholder"]),
    _createVNode(TextInput, {
      is: "textarea",
      id: "form-message",
      modelValue: formData.value.message,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.message) = $event)),
      required: "",
      disabled: areInputsDisabled.value,
      withHiddenLabel: "",
      name: "message",
      labelText: _ctx.$tr('contactForm.message'),
      placeholder: _ctx.$tr('contactForm.message')
    }, null, 8, ["modelValue", "disabled", "labelText", "placeholder"]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.submitContainer)
    }, [
      _createVNode(Button, {
        class: _normalizeClass([_ctx.$style.submitBtn, buttonProps.value.class]),
        size: "l",
        color: buttonProps.value.color,
        type: buttonProps.value.type,
        iconLeft: buttonProps.value.iconLeft,
        disabled: buttonProps.value.disabled,
        interfaceTarget: buttonProps.value.interfaceTarget,
        onClick: buttonProps.value.onClick
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(buttonProps.value.title), 1)
        ]),
        _: 1
      }, 8, ["class", "color", "type", "iconLeft", "disabled", "interfaceTarget", "onClick"]),
      _createVNode(Typography, {
        is: "p",
        size: _ctx.viewMode === 'modal' ? 'xs' : 's',
        class: _normalizeClass(_ctx.$style.submitHint)
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.mutedText)
          }, _toDisplayString(_ctx.$tr('contactForm.agreementTextStart')), 3),
          _createVNode(Link, {
            to: "/termsofuse",
            color: "purple-500",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tr('contactForm.termsOfUse')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.mutedText)
          }, _toDisplayString(_ctx.$tr('contactForm.agreementTextAnd')), 3),
          _createVNode(Link, {
            to: privacyPolicyRoute.value.to,
            externalTo: privacyPolicyRoute.value.externalTo,
            color: "purple-500",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(privacyPolicyRoute.value.title), 1)
            ]),
            _: 1
          }, 8, ["to", "externalTo"])
        ]),
        _: 1
      }, 8, ["size", "class"])
    ], 2)
  ], 34))
}
}

})